<template>
    <b-modal v-model="show" title="Mensagens Prontas" size="lg" centered scrollable>
        <b-container fluid>
            <b-row>
                <!-- Coluna para Menus e Submenus -->
                <b-col cols="4" class="pl-0">
                    <b-list-group class="h-100">
                        <!-- Navegação entre menus -->
                        <div v-for="(menu, menuIndex) in allMensagens" :key="'menu-' + menuIndex">
                            <b-list-group-item
                                @click="showMenuContent(menuIndex)"
                                style="cursor: pointer"
                                class="d-flex justify-content-between align-items-center text-white"
                                :class="{'bg-menu': true}">
                                {{ menu.menu }}
                                <b-icon :icon="activeMenuIndex === menuIndex ? 'caret-down-fill' : 'caret-right-fill'" class="text-white"></b-icon>
                            </b-list-group-item>
                            <!-- Submenus do menu ativo -->
                            <b-list-group v-if="activeMenuIndex === menuIndex" class="sub-menu-list">
                                <b-list-group-item
                                    v-for="(submenu, submenuIndex) in submenus"
                                    :key="'submenu-' + submenuIndex"
                                    @click="toggleSubmenuVisibility(submenuIndex)"
                                    class="d-flex justify-content-between align-items-center pl-4"
                                    :class="{'bg-submenu': true, 'bg-active': activeSubmenuIndex === submenuIndex}">
                                    {{ submenu.name }}
                                </b-list-group-item>
                            </b-list-group>
                        </div>
                    </b-list-group>
                </b-col>
                <!-- Coluna para Mensagens -->
                <b-col cols="8" class="p-3">
                    <b-alert show variant="info" v-if="mensagens.length > 0"><strong>Clique na mensagem para selecionar.</strong></b-alert>
                    <b-alert show variant="info" v-else><strong>Selecione um departamento para abrir as mensagens</strong></b-alert>
                    <div class="balloon" v-for="(msg, index) in mensagens" :key="index">
                        <p @click="selectMessage(msg)" v-html="formatMessage(msg)"></p>
                    </div>
                </b-col>
            </b-row>
        </b-container>
    </b-modal>
</template>


<script>
import { mapGetters } from "vuex";
const msgPronta = require("./../../../modules/newScrean/mensagem/mensagensProntas");

export default {
    name: "MensagemPronta",
	data: () => ({
		show: false,
		search: "",
		activeMenuIndex: null,
		activeSubmenuIndex: null,
		allMensagens: [],
		submenus: [],
		mensagens: [],
		isBusca: false,
		nameContact: "",
		submenuVisibility: {}  // Adicionar um novo objeto para controlar a visibilidade
	}),
    created() {
        this.allMensagens = msgPronta.getMensagens();
        this.activeMenuIndex = 0;
        this.submenus = this.allMensagens.length > 0 ? this.allMensagens[0].submenus : [];
    },
    methods: {
		toggleSubmenuVisibility(submenuIndex) {
			if (this.activeSubmenuIndex === submenuIndex) {
				// Se o mesmo submenu for clicado novamente, apenas retorna sem fazer nada
				return;
			} else {
				// Atualiza o submenu ativo e carrega suas mensagens
				this.activeSubmenuIndex = submenuIndex;
				this.mensagens = this.submenus[submenuIndex].mensagens;
			}
		},
        selectMessage(msg) {
            let result = msg.replace(/%nome_contato%/g, this.nameContact);
            window.$eventMessage.$emit("sendMensagem", result);
            this.show = false;
            this.search = "";
        },
        formatMessage(msg) {
            let result = msg.replace(/%nome_contato%/g, this.nameContact);
            result = result.replace(/\n/g, "<br/>");
            return result;
        },
		showMenuContent(menuIndex) {
			if (this.activeMenuIndex === menuIndex) {
				// Se o mesmo menu for clicado novamente, recolher seus submenus
				this.activeMenuIndex = null;
				this.submenus = [];
				this.mensagens = [];
			} else {
				// Expande o novo menu selecionado
				this.activeMenuIndex = menuIndex;
				this.submenus = this.allMensagens[menuIndex].submenus;
				this.activeSubmenuIndex = null; // Garante que nenhum submenu esteja selecionado inicialmente
				this.mensagens = []; // Limpa as mensagens até que um submenu específico seja clicado

				// Resetar a visibilidade dos submenus para garantir que eles sejam exibidos corretamente
				this.submenuVisibility = {};
				this.submenus.forEach((_, index) => {
					this.submenuVisibility[index] = false;
				});
			}
		},
        showSubmenuContent(submenuIndex) {
			this.activeSubmenuIndex = submenuIndex;
			this.mensagens = this.submenus[submenuIndex].mensagens;
		},
    }
};
</script>

<style scoped lang="scss">
.rounder {
    border-radius: 0.5em 0 0 0.5em !important;
}

.bg-menu {
    background-color: #0c5460; // Cor de fundo para o menu principal
    color: white; // Cor do texto para o menu principal
}

.bg-submenu {
    background-color: #1b6f7d; // Cor de fundo para os submenus
    color: black; // Cor do texto para os submenus
}

.input-group-text {
    border-radius: 0 0.5em 0.5em 0 !important;
    width: 37px !important;
    border: 1px solid #ccc !important;
    background-color: white !important;
}
.bg-active {
	color: black;
    background-color: #19a090; // Mais escuro ao passar o mouse sobre os submenus
    color: white;
    
}

.bg-adv {
    background-color: #007b6d; // Cor de fundo para itens não ativos
    color: #f0f0f0; // Cor de texto para itens não ativos
}

.list-group-item {
    transition: background-color 0.3s; // Suaviza a transição de cor
    &:hover {
		background-color: #007b6d; // Cor de fundo para submenu ativo
    	color: white; // Cor do texto para submenu ativo
        cursor: pointer;
    }
}

.b-icon {
    transition: transform 0.2s ease-in-out; /* Suaviza a transição da rotação */
}

.bg-active .b-icon {
    transform: rotate(0deg); /* Roda o ícone para o estado 'aberto' */
}

.bg-adv .b-icon {
    transform: rotate(-90deg); /* Roda o ícone de volta para o estado 'fechado' */
}

.balloon::v-deep {
    p {
        position: relative;
        max-width: 82%;
        background-color: #ccc;
        padding: 1em;
        font-size: 1em;
        border-radius: 0.7rem 0 0.7rem 0.7rem;
        cursor: pointer;
        margin-left: 15%;
        overflow-wrap: break-word;

        &:hover {
            box-shadow: 0 0.125rem 0.5rem rgba(0, 0, 0, 0.3),
                        0 0.0625rem 0.125rem rgba(0, 0, 0, 0.2);
        }

        &::before {
            content: "";
            width: 0;
            height: 0;
            position: absolute;
            border-left: 15px solid #ccc;
            border-right: 15px solid transparent;
            border-top: 15px solid #ccc;
            border-bottom: 15px solid transparent;
            right: -16px;
            top: 0;
        }
    }

}

.modal-body {
    padding: 10px; // Ajuste se necessário, estava faltando a unidade 'px'
}
</style>
